module.exports = __webpack_public_path__ + "static/media/flappyboy.gb.0c981b1e.zip";